import DetailHeader from 'components/DetailHeader';
import FanLoadingIcon from 'components/FanLoadingIcon';
import { DIALOG_ERROR_GENERAL_ERROR_MESSAGE, DIALOG_ERROR_INVALID_STATUS_TO_SEND_MAIL, DIALOG_MESSAGE_CONFIRM_SEND_MESSAGE, DIALOG_MESSAGE_SENT_MESSAGE_SUCCESSFULLY, TEXT_CREATE_SENSOR, TEXT_SENSOR_LIST, TEXT_SENSOR_MANAGEMENT, TEXT_UPDATE_SENSOR } from 'constants/message';
import { useDialog } from 'context/DialogContext';
import { AccountType } from 'models';
import { useAuth } from 'context/AuthContext';
import { useGeneralSetting } from 'context/GeneralSettingContext';
import { useNotifications } from 'context/NotificationContext';
import { useSensorGroups } from 'context/SensorGroupsContext';
import { useSensors } from 'context/SensorsContext';
import { useForcedLogout } from 'hooks/useForcedLogout';
import { SensorType } from 'models';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  FLOOD_GATE_MESSAGES,
  PAGE_CAMERA_SENSOR_LIST,
  PAGE_CREATE_SENSOR,
  PAGE_FLOOD_GATE_SENSOR_LIST,
  PAGE_FLOOD_SENSOR_LIST,
  PAGE_GENERAL_SENSOR_LIST,
  PAGE_LINK,
  PAGE_MAP,
  PAGE_MASTER_MANAGEMENT,
  PAGE_MODIFY_SENSOR,
  PAGE_PROFILE,
  PAGE_SENSOR_MANAGEMENT,
  PAGE_USER_MANAGEMENT,
  PAGE_VIEW_SENSOR,
  PAGE_LOCATION,
  PAGE_SPLIT,
  PAGE_BASE,
  PAGE_TRAFFIC,
  MENU_TYPE,
  PAGE_TRAFFIC_MONITORING_SETTINGS,
  PAGE_DETAIL_TRAFFIC_MONITORING_SETTINGS
} from 'utils/constanst';
import MapPage from './Map/MapPage';
import MasterManagementPage from './MasterManagement/MasterManagementPage';
import "./PageWrapper.css";
import ProfilePage from './Profile/ProfilePage';
import SensorListPage from './SensorList/SensorListPage';
import ModifySensorForm from './SensorList/components/ModifySensorForm';
import SensorDetailHeader from './SensorList/components/SensorDetailHeader';
import SensorDetailView from './SensorList/components/SensorDetailView';
import SensorDetailViewCamera from './SensorList/components/SensorDetailViewCamera';
import UserManagementPage from './UserManagement/UserManagementPage';
import LocationPage from './Location/LocationPage';
import SplitPage from './Split/SplitPage';
import BasePage from './Base/BasePage';
import TrafficPage from './Traffic/TrafficPage';
import TrafficMonitoring from './TrafficMonitoring/TrafficMonitoring';
import TrafficMonitoringDetail from './TrafficMonitoringDetail/TrafficMonitoringDetail';
import FloatMenu from './components/FloatMenu';
import TabMenu from './components/TabMenu';
import NotificationBadge from './components/NotificationBadge';
import { SENSOR_STATUS_ABNORMAL, SENSOR_STATUS_ALERT, SENSOR_STATUS_GATE_CLOSED, SENSOR_STATUS_GATE_OPENED, SENSOR_STATUS_NORMAL } from 'constants/config';
import { apiSendMail } from 'apis/MailApi';
import Icon, { IconList } from 'components/Icon';

const propTypes = {};
const defaultProps = {};
const PageWrapper = (props) => {
  const { topPage } = props
  /*** States and Variables ***/
  const navigate = useNavigate();
  const { id: sensorId } = useParams()
  const mapRef = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [zoom, setZoom] = React.useState(5);
  // Thêm state để quản lý việc hiển thị drawer trên di động
  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const { currentUser } = useAuth();
  const { generalSetting } = useGeneralSetting();
  const { sensorGroups } = useSensorGroups();
  const { error, confirm, success } = useDialog();
  const { sensors } = useSensors();
  const { notificationsValid } = useNotifications()
  const [showNotification, setShowNotification] = React.useState(true);

  const currentSensor = sensors?.find(item => item.id === sensorId)
  const targetGroup = sensorGroups?.find(g => g.id === currentSensor?.groupId);
  useForcedLogout(generalSetting);

  /*** Processing ***/
  React.useEffect(() => {
    document.title = generalSetting?.appTitle || 'ENEPEACE';
  }, [generalSetting])

  /*** Sub Components ***/
  const renderDetailView = (item) => {
    if (!targetGroup) return <></>
    return targetGroup?.type === SensorType.CAMERA ? <SensorDetailViewCamera sensor={item} targetGroup={targetGroup} /> : <SensorDetailView sensor={item} targetGroup={targetGroup} onBack={() => { navigate(-1) }} />;
  }
  const renderModifyForm = () => {
    return <div className='sensor_list_page_modify_form_container'>
      <ModifySensorForm sensor={currentSensor} onCancel={() => { navigate(-1) }} />
    </div>;
  }
  /*** Event Handlers ***/
  const onMapLoad = (map) => mapRef.current = map;

  const onFocusOnSensor = async (sensor) => {
    navigate('/')
    mapRef.current.flyTo({ lat: sensor.lat, lon: sensor.lng }, mapRef.current.getZoom());
  }

  const onSendMail = async (sensor) => {
    if (loading) return;
    const targetGroup = sensorGroups.find(g => g.id === sensor.groupId)
    const statusValue = sensor.status;
    if (statusValue === -1) {
      error(DIALOG_ERROR_INVALID_STATUS_TO_SEND_MAIL);
      return;
    }
    confirm(DIALOG_MESSAGE_CONFIRM_SEND_MESSAGE, async () => {
      setLoading(true);
      const res = await handleSendMail(sensor, targetGroup)
      setLoading(false);
      if (res.success) {
        success(DIALOG_MESSAGE_SENT_MESSAGE_SUCCESSFULLY);
      }
      else {
        error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
      }
    });
  }

  const onViewSensor = (sensor, state = {}) => {
    navigate(`/view-sensor/${sensor.id}`, { state })
  }

  const onEditSensor = (sensor) => {
    navigate(`/modify-sensor/${sensor.id}`)
  }

  const onNavigate = (type) => {
    navigate(PAGE_LINK[type])
  }

  // Hàm điều hướng mới để đóng drawer sau khi nhấp
  const handleNavigateAndCloseDrawer = (type) => {
    onNavigate(type);
    setDrawerVisible(false);
  }

  const handleSendMail = async (sensor, targetGroup) => {
    const status = targetGroup.messages[sensor.status].value;
    let res = { success: true };
    if (targetGroup?.type === SensorType.FLOOD) {
      const subject = status !== SENSOR_STATUS_ABNORMAL ? `【${status}】冠水警報システム ${sensor.name} ${status}レベル水位` : `【${status}】冠水警報システム ${sensor.name} ${status}発生`;
      let body = status !== SENSOR_STATUS_ABNORMAL ? `${sensor.name}の水位が${status}レベルになりました。` : `${sensor.name}の機器で${status}が発生しました。`;
      body += '<br>https://kure.nodeviewer2.com/login';
      res = await apiSendMail(subject, body);
    }
    else if (targetGroup?.type === SensorType.FLOOD_GATE) {
      const allStatuses = sensor?.data?.allStatuses;
      if (allStatuses) {
        const statusGroups = {
          [SENSOR_STATUS_ABNORMAL]: allStatuses.filter(s => s <= 7),
          [SENSOR_STATUS_ALERT]: allStatuses.filter(s => s > 7 && s <= 11),
          [SENSOR_STATUS_GATE_CLOSED]: allStatuses.filter(s => s === 12 || s === 13),
          [SENSOR_STATUS_GATE_OPENED]: allStatuses.filter(s => s === 14)
        }
        for (const tempStatus of Object.keys(statusGroups)) {
          if (!statusGroups[tempStatus].length) continue;
          const tempSubject = tempStatus === SENSOR_STATUS_GATE_CLOSED || tempStatus === SENSOR_STATUS_GATE_OPENED ? `【${status}】Nodeviewer2　${sensor.name}　水門${status}` : `【${tempStatus}】Nodeviewer2　${sensor.name}　${tempStatus}発生`;
          let tempBody = tempStatus === SENSOR_STATUS_GATE_CLOSED || tempStatus === SENSOR_STATUS_GATE_OPENED ? `${sensor.name}の水門が${status}状態になりました。` : `${sensor.name}の水門で${status}が発生しました。`;
          for (const s of statusGroups[tempStatus]) {
            tempBody += '<br>' + FLOOD_GATE_MESSAGES[s];
          }
          tempBody += '<br>https://kure.nodeviewer2.com/login';
          const tempRes = await apiSendMail(tempSubject, tempBody);
          res.success = !res.success ? res.success : tempRes.success;
        }
      }
    } else if (targetGroup?.type === SensorType.GENERAL) {
      const tempSubject = status === SENSOR_STATUS_NORMAL ? `【${status}】遠隔監視システム 汎用センサ 平常` : status === SENSOR_STATUS_ALERT ? `【${status}】遠隔監視システム 汎用センサ 警報発生` : `【${status}】遠隔監視システム 汎用センサ 異常発生`;
      let tempBody = status === SENSOR_STATUS_NORMAL ? `汎用センサが平常値に戻りました。` : status === SENSOR_STATUS_ALERT ? `汎用センサで警報が発生しました。` : `汎用センサで異常が発生しました。`;
      tempBody += '<br>https://kure.nodeviewer2.com/login';
      const tempRes = await apiSendMail(tempSubject, tempBody);
      res.success = !res.success ? res.success : tempRes.success;
    }
    return res
  }

  /*** Main Render ***/
  return <div className='page_wrapper_container' style={{ overflow: topPage !== PAGE_MAP ? 'auto' : '' }}>
    <div className='page_wrapper_body' >
      <MapPage
        isTop={topPage === PAGE_MAP}
        onSendMail={onSendMail}
        onMapLoad={onMapLoad}
        onZoomChange={setZoom}
        onViewSensorDetail={onViewSensor} />
      {
        topPage !== PAGE_MAP &&
        <div className='page_wrapper_top_page_container'>
          {([PAGE_FLOOD_SENSOR_LIST, PAGE_FLOOD_GATE_SENSOR_LIST, PAGE_SENSOR_MANAGEMENT, PAGE_CAMERA_SENSOR_LIST, PAGE_GENERAL_SENSOR_LIST].includes(topPage)) &&
            <SensorListPage
              isManagementPage={topPage === PAGE_SENSOR_MANAGEMENT}
              onFocusOnSensor={onFocusOnSensor}
              onViewSensor={onViewSensor}
              onEditSensor={onEditSensor}
              onSendMail={onSendMail}
              sensorType={topPage === PAGE_FLOOD_SENSOR_LIST ? SensorType.FLOOD : topPage === PAGE_FLOOD_GATE_SENSOR_LIST ? SensorType.FLOOD_GATE : topPage === PAGE_CAMERA_SENSOR_LIST ? SensorType.CAMERA : topPage === PAGE_GENERAL_SENSOR_LIST ? SensorType.GENERAL : undefined}
              onChangeSensorType={onNavigate} />}
          {topPage === PAGE_PROFILE &&
            <ProfilePage />}
          {topPage === PAGE_USER_MANAGEMENT &&
            <UserManagementPage />}
          {topPage === PAGE_MASTER_MANAGEMENT &&
            <MasterManagementPage />}
          {topPage === PAGE_LOCATION && <LocationPage />}
          {topPage === PAGE_SPLIT && <SplitPage />}
          {topPage === PAGE_BASE && <BasePage onViewSensorDetail={onViewSensor} />}
          {topPage === PAGE_TRAFFIC && <TrafficPage />}
          {topPage === PAGE_TRAFFIC_MONITORING_SETTINGS && <TrafficMonitoring />}
          {topPage === PAGE_DETAIL_TRAFFIC_MONITORING_SETTINGS && <TrafficMonitoringDetail />}
          {topPage === PAGE_VIEW_SENSOR && currentSensor && (
            <>
              <SensorDetailHeader
                sensor={currentSensor}
                targetGroup={targetGroup}
                onFocusItem={onFocusOnSensor}
                onSendMail={onSendMail}
                handleComeback={onNavigate}
              />
              {renderDetailView(currentSensor)}
            </>
          )}
          {(topPage === PAGE_MODIFY_SENSOR || topPage === PAGE_CREATE_SENSOR) && (
            <>
              <DetailHeader
                mainLabel={TEXT_SENSOR_MANAGEMENT}
                subLabel={currentSensor ? TEXT_UPDATE_SENSOR : TEXT_CREATE_SENSOR}
                onClick={() => { navigate(-1) }}
              />
              {renderModifyForm()}
            </>
          )}
        </div>
      }
      {topPage === PAGE_MAP && showNotification && notificationsValid.length > 0 && (
        <NotificationBadge items={notificationsValid} onClose={() => { setShowNotification(false) }} />
      )}

      <div className="page_wrapper_desktop_menus" data-menu-type={generalSetting?.menuType || ''}>
        {generalSetting?.menuType === MENU_TYPE.TAB && (
          <TabMenu
            selectedItem={topPage}
            onClickItem={onNavigate}
            popupZoomRatio={generalSetting?.popupZoomRatio}
            zoom={zoom}
          />
        )}
        <FloatMenu selectedItem={topPage} onClickItem={onNavigate} />
      </div>
      <div className="page_wrapper_mobile_drawer" data-menu-type={generalSetting?.menuType || ''}>
        <button className="drawer-toggle" onClick={() => setDrawerVisible(true)}>
          <Icon icon={IconList.iconCollapseMenu} containerStyle='drawer-toggle-container' iconStyle='drawer-toggle-icon' />
        </button>
        {drawerVisible && generalSetting.menuType === MENU_TYPE.TAB && (
          <>
            <div className="drawer-overlay" onClick={() => setDrawerVisible(false)}></div>
            <div className="drawer-content">
              <div className="drawer-menus">
                {generalSetting?.menuType === MENU_TYPE.TAB && (
                  <TabMenu
                    selectedItem={topPage}
                    onClickItem={handleNavigateAndCloseDrawer}
                    popupZoomRatio={generalSetting?.popupZoomRatio}
                    zoom={zoom}
                  />
                )}
                <FloatMenu selectedItem={topPage} onClickItem={handleNavigateAndCloseDrawer} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    {loading && <FanLoadingIcon size={80} />}
  </div>;
}

PageWrapper.propTypes = propTypes;
PageWrapper.defaultProps = defaultProps;
export default PageWrapper;
